import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import AboutHero from './components/AboutHero';
import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useScrollToTop } from '@/hooks/useScrollToTop';

export default function About() {
  useScrollToTop();
  const { setMeta } = useDocumentMeta();

  const ogImage = "https://readdy.ai/api/search-image?query=Abstract%20warm%20elegant%20brand%20about%20us%20page%20banner%20with%20soft%20cream%20and%20terracotta%20tones%2C%20minimal%20editorial%20design&width=1200&height=630&seq=og-about&orientation=landscape";

  useEffect(() => {
    setMeta({
      title: '关于我们 - 精品一区·优选内容汇聚地',
      description: '精品一区成立于2020年，致力于为追求品质生活的读者提供最有价值的精选内容。了解精品一区的品牌故事、读者口碑与联系方式，立即探索精品一区带来的全新内容体验。',
      keywords: '精品一区,关于精品一区,精品一区品牌,精品一区联系方式,精品内容平台介绍',
      canonicalUrl: 'https://jingpinyiqu.com/about',
      ogImage,
      ogType: 'website',
      structuredData: {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'AboutPage',
            name: '关于精品一区',
            description: '精品一区成立于2020年，专注于为读者提供高质量的精选内容。',
            url: 'https://jingpinyiqu.com/about',
            isPartOf: { '@type': 'WebSite', name: '精品一区' },
          },
          {
            '@type': 'Organization',
            name: '精品一区',
            url: 'https://jingpinyiqu.com',
            description: '精品一区是您发现高质量精选内容的首选平台。',
            foundingDate: '2020',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '建国路88号精品大厦15层',
              addressLocality: '北京市',
              addressRegion: '朝阳区',
              postalCode: '100022',
              addressCountry: 'CN',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-9999',
              email: 'contact@jingpinyiqu.com',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
          },
          {
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, item: { '@id': 'https://jingpinyiqu.com', name: '首页' } },
              { '@type': 'ListItem', position: 2, item: { '@id': 'https://jingpinyiqu.com/about', name: '关于我们' } },
            ],
          },
        ],
      },
    });
  }, [setMeta]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-16">
        <AboutHero />
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-4">
          <Breadcrumbs items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />
        </div>
        <BrandIntro />
        <Reputation />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}